/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

let spImgList = [
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/202407181-p1_83b4fb39-b87d-4c74-bdf7-994d9b0fe6a2.png?v=1746503897',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/1_e0895a3c-1f47-4193-aa8c-9a3b02843468.png?v=1746503815',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/202407181-p3.png',
]

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            260 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()

// 数量
let prods = window.product

function getCur() {
  let color = $('#sp-color div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.filter(item => item.option1 == size && item.option2 == color)[0]
}
function changePrice() {
  let num = $('#calcNumber').val()
  let price = (getCur().price / 100).toFixed(2)
  let compare = (getCur().compare_at_price / 100).toFixed(2)
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font =
    100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
  $('.product-part .sp-brand span').html(off_font + '%')
}
changePrice()
$('.sp-buynow').click(function () {
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
// 弹窗 start
var main_id = ''
$('.emitCheckout').click(function () {
  console.log('1111')
  main_id = getCur().id
  // main_id = $(this).siblings('.select_span').find('span.on').data('id')
  // window.location.href = "/cart/" + id + ":1"
})

function getPopProdId() {
  let selectVals = []
  $('.overbuy_wrap .sp-subopt.active').each(function () {
    selectVals.push($(this).data('val'))
  })

  let cur = popProduct.filter(item => {
    let option1 = selectVals[0]
    let option2 = null
    let option3 = null
    if (selectVals[1]) {
      option2 = selectVals[1]
    }
    if (selectVals[2]) {
      option3 = selectVals[2]
    }

    return (
      item.option1 == option1 &&
      item.option2 == option2 &&
      item.option3 == option3
    )
  })

  return cur[0]
}
var imgArr = [
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250429-pro4.png?v=1745914013',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250429-pro5.png?v=1745914013',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250429-pro1.png?v=1745914013',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250429-pro2.png?v=1745914013',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250506-pro3.png?v=1746515755',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250506-pro4.png?v=1746515755',
]
$('.overbuy_img img').attr(
  'src',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250429-pro4.png?v=1745914013'
)
$('.overbuy_img img').attr(
  'srcset',
  'https://cdn.shopify.com/s/files/1/0911/1342/3214/files/20250429-pro4.png?v=1745914013'
)

$('.overbuy-select div').click(function () {
  $(this).siblings().removeClass('active')
  $(this).addClass('active')
  let bindVal2 = $('.overbuy-select').eq(1).find('.active').index()
  let bindVal3 = $('.overbuy-select').eq(2).find('.active').index()
  console.log(bindVal2, bindVal3)
  let indexImg = bindVal2 + bindVal3 * 2
  $('.overbuy_img img').attr('srcset', imgArr[indexImg])
  $('.overbuy_img img').attr('src', imgArr[indexImg])
  let cur = getPopProdId()

  if (cur) {
    $('.main-btn').text('FÅ 10% RABATT').removeClass('overbuy_disabled')
    let _price = parseFloat(cur.price / 100).toFixed(2)
    let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2)

    $('.overbuy_price span')
      .eq(0)
      .html(_price + 'kr')
    $('.overbuy_price span')
      .eq(1)
      .html(_compare_at_price + 'kr')
  } else {
    $('.main-btn').text('Unavailable').addClass('overbuy_disabled')
  }
})

window.emitSubmit = function (_type) {
  let num = $('#calcNumber').val()
  if (_type == 'all') {
    // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
    let _id = getPopProdId()?.id
    if (!_id) return
    console.log(_id)

    window.location.href = `/cart/${main_id}:${num},${_id}:1`
  } else {
    window.location.href = `/cart/${main_id}:${num}`
  }
}

// 弹窗 end
$('.sp-reduce').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) - 1
  if (num > 0) {
    input.value = num
    // changePrice()
  }
})

$('.sp-add').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) + 1
  input.value = num
  // changePrice()
})

$(function () {
  $('.option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    changePrice()
    // style选项
    let colorOptions = $('#sp-color .option.active').index()
    console.log(colorOptions)
    const cur = getCur()
    $('.product-part .p-img')[0].src = spImgList[colorOptions]
    if (colorOptions == 1) {
      $('.product-part .img-wrap').addClass('p2').removeClass('p3')
      spNum = 2

      $('#sp_price3').html((cur.price / 100 / 3).toFixed(2))
      $('#spText').css('display', 'flex')
    } else if (colorOptions == 2) {
      $('.product-part .img-wrap').addClass('p3').removeClass('p2')
      $('#sp_price3').html((cur.price / 100 / 5).toFixed(2))
      spNum = 5
      $('#spText').css('display', 'flex')
    } else {
      $('.product-part .img-wrap').removeClass('p2 p3')
      spNum = 1
      $('#spText').hide()
    }

    let index = $('#sp-size .option.active').index()
    $('.select_option').html(window.options_with_values[0].values[index])
  })

  // style选项
  // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  // 购物车加购动效
  $('.cart-btn').click(function () {
    $(this).children('img').addClass('on')
    $('.sp-header-top .sp-cart .num').show()
    setTimeout(function () {
      $('.cart-btn').children('img').removeClass('on')
    }, 500)
    $('.sp-header-top .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-header-top .sp-cart').removeClass('on')
    }, 500)
  })
  let initNum = 0
  // $(".product-part .cart-btn").click(function () {
  //   let spNum = $(".product-part #calcNumber")[0].value;
  //   initNum += Number(spNum);
  //   $("#calcNumber").val(spNum);

  //   $("#cardNum").html(initNum);
  //   // handleAddToCart(initNum);

  //   var img = $(".product-part .p-img");

  //   var flyer = img[0].cloneNode(true);
  //   flyer.classList.add("sp_clone");

  //   $(".product-part").append(flyer);
  //   $(".sp_clone").css({
  //     width: img[0].width,
  //     height: img[0].height,
  //     background: "#e7e9ef",
  //     position: "fixed",
  //     top: img[0].offsetTop,
  //     left: img.offset().left,
  //     "z-index": "99",
  //   });

  //   let finish = $(".sp-cart");
  //   $(".sp_clone").animate(
  //     {
  //       top: finish[0].offsetTop + $(".time-part").height(),
  //       left: finish[0].offsetLeft + finish.width() / 2,
  //       width: 50, // 结束时的大小，根据需要调整
  //       height: 50, // 结束时的大小，根据需要调整
  //       opacity: 0.4,
  //     },
  //     500,
  //     "linear",
  //     function () {
  //       $(this).animate(
  //         {
  //           width: 0,
  //           height: 0,
  //           opacity: 0,
  //         },
  //         0,
  //         function () {
  //           $(this).detach();
  //         }
  //       );
  //     }
  //   );
  // });

  $('.product-part .cart-btn').click(function () {
    // do something here
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('#cardNum').html(result.item_count)
        })
      },
      dataType: 'json',
    })

    var img = $('.product-part .p-img')
    var flyer = img[0].cloneNode(true)
    flyer.classList.add('sp_clone')
    $('.product-part').append(flyer)
    $('.sp_clone').css({
      width: '876px',
      height: '513px',
      position: 'fixed',
      top: img[0].offsetTop,
      left: img.offset().left,
      'z-index': '99',
    })
    $('.sp-cart').addClass('shake')
    setTimeout(() => {
      $('.sp-cart').removeClass('shake')
    }, 1000)
    let finish = $('.sp-cart')
    $('.sp_clone').animate(
      {
        top: 195,
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      1000,
      'linear',
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach() // 完成动画后移除克隆的图片
          }
        )
      }
    )
  })
})
